import classNames from 'classnames/bind';
import { DurationMap } from 'common/types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  curDur: string;
  onSelect: (dur: string) => void;
}

const StayDuration = ({ curDur, onSelect }: IProps) => {
  const durationArray = Array.from(DurationMap);
  const clickHandle = (durKey: string) => () => {
    onSelect(durKey);
  };
  return (
    <div className={cx('stay_duration')}>
      <b className={cx('title')}>체류기간</b>
      <ul className={cx('list')} role="listbox">
        {durationArray.map(([durKey, durKor], index) => (
          <li
            className={cx('item')}
            role="option"
            aria-selected={curDur === durKey}
            key={`${index}${durKey}`}
            data-event-nlog="click"
            data-event-area-code="cal.openstay"
            onClick={clickHandle(durKey)}
          >
            {durKor}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StayDuration;
